import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfParticipentAction = createAsyncThunk(
    'no-of-participent',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/no-of-participent?&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfParticipentSlice = createSlice({
    name: 'no-of-participent',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfParticipentAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfParticipentAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfParticipentAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfParticipentReducer = noOfParticipentSlice.reducer